import { render, staticRenderFns } from "./BacklogByLocation.vue?vue&type=template&id=6a9e122c&scoped=true"
import script from "./BacklogByLocation.vue?vue&type=script&lang=js"
export * from "./BacklogByLocation.vue?vue&type=script&lang=js"
import style0 from "./BacklogByLocation.vue?vue&type=style&index=0&id=6a9e122c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a9e122c",
  null
  
)

export default component.exports